import { render, staticRenderFns } from "./BackNavigationHeader.vue?vue&type=template&id=23b51ca4&scoped=true&"
import script from "./BackNavigationHeader.vue?vue&type=script&lang=js&"
export * from "./BackNavigationHeader.vue?vue&type=script&lang=js&"
import style0 from "./BackNavigationHeader.vue?vue&type=style&index=0&id=23b51ca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b51ca4",
  null
  
)

export default component.exports